import {NextPage} from 'next';
import {ContainerComponent} from '../../../core/components/container.component';
import {useTranslation} from 'react-i18next';
import {RowComponent} from "../../../core/components/base/row.component";
import {toPersianNumber} from "../../../core/utils/number.utils";

const Contact: NextPage = () => {
    const {t} = useTranslation();
    return (
        <ContainerComponent>
            <div className={'text-2xl text-bold mt-4 px-4'}>{t('profile.contactUs')}</div>
            <RowComponent className={"totalCenter mt-4 px-4"}>
                <div className={'text-base leading-10 grow shrink-0'}>{t('profile.phone')}</div>
                <a className={"w-full text-start px-4"} href={"tel:86085801"} rel={"phoneNumber"}>{toPersianNumber("02186085801")}</a>
            </RowComponent>
            <RowComponent className={"totalCenter mt-2 px-4"}>
                <div className={'text-base leading-10 grow shrink-0'}>{t('profile.email')}</div>
                <a className={"w-full text-start px-4"} href={"mailto:support@tlbx.ir"} rel={"email"}>{toPersianNumber("support@tlbx.ir")}</a>
            </RowComponent>
            <div className={'text-base mt-2 px-4 w-full leading-10 text-ellipsis'}>{t('detail.contactUs')}</div>
        </ContainerComponent>
    );
};

export default Contact;
